import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { Subscription } from 'rxjs';
import { ReportingService } from '../reporting-service.service';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { SharedServicesService } from '../../../shared/sharedservices/shared-services.service';
import { DeleteQueueFilterDto, ReportMainData } from 'app/ReportingModel/ReportFiltering';
import { Report } from 'app/ReportingModel/ReportConstantsDto';
import { DatePipe } from '@angular/common';
import { unescape } from 'lodash';
import { DownloadReportInputDto, DownloadReportDto } from 'app/ReportingModel/GenerateReportDto';

@Component({
    selector: 'app-queued-report',
    templateUrl: './queued-report.component.html',
    styleUrls: ['./queued-report.component.scss']
})
export class QueuedReportComponent implements OnInit {
    @Input() ReportMainData: ReportMainData;
    @Output() selectedTab = new EventEmitter<any>();
    tabVal: string = 'QueuedReport';
    selectedTabVal: string = 'Resource'; // Default selected tab
    queuedReportsSubscription: Subscription;
    queuedReports: any[];
    queuedReportsdataSource = new MatTableDataSource();
    tabClass = "chevron_right";
    applyDiv2Class: boolean = true;
    queuedReportsColumns: string[] = [
        'ReportStatus',
        'ErrorMessage',
        'ReportFileName',
        'RequestedDate',
        'UpdatedDate',
        'Actions'
    ];
    messageBody = '';
    messageTitle = '';
    constructor(private restService: ReportingService, private router: Router, private spinner: NgxSpinnerService,
        private restSharedService: SharedServicesService) { }

    ngOnInit(): void {
        this.getQueuedReports(this.ReportMainData.reportId);
    }
    getQueuedReports(reportId) {
        this.spinner.show();
        this.queuedReports = [];
        this.queuedReportsdataSource = new MatTableDataSource();
        this.queuedReportsSubscription =
            this.restService.GetQueuedReports(reportId).subscribe(
                (data) => {
                    this.queuedReports = data;
                    this.queuedReportsdataSource.data = this.queuedReports;
                    this.queuedReportsdataSource.data.forEach((element: any) => {
                        element.RequestedDate = this.dateTimeConversion(element.RequestedDate);
                        if (element.UpdatedDate != null && element.UpdatedDate != undefined)
                            element.UpdatedDate = this.dateTimeConversion(element.UpdatedDate);
                    });
                    this.spinner.hide();
                },
                (error) => {
                    console.log(error);
                },
                () => {
                    this.spinner.hide();
                }
            );
    }

      private dateTimeConversion(inputDateString): string {

        const parsedDate = new Date(inputDateString);

        // const daysOfWeek = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
        const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

        //const dayOfWeek = daysOfWeek[parsedDate.getDay()];
        const month = months[parsedDate.getMonth()];
        const day = parsedDate.getDate();
        const year = parsedDate.getFullYear();

        const hours = parsedDate.getHours();
        const minutes = parsedDate.getMinutes();
        const seconds = parsedDate.getSeconds();

        // Determine if it's AM or PM and convert hours to 12-hour format
        const period = hours >= 12 ? 'PM' : 'AM';
        const twelveHourFormatHours = hours % 12 || 12; // Convert 0 to 12 for midnight

        // Construct the formatted date string
        const formattedDate = `${day} ${month}, ${year}`;

        // Construct the formatted time string in 12-hour clock format
        //const formattedTime = `${twelveHourFormatHours}:${padZero(minutes)}:${padZero(seconds)} ${period}`;
        const formattedTime = `${twelveHourFormatHours}:${padZero(minutes)}:${period}`;

        function padZero(num) {
            return num < 10 ? `0${num}` : `${num}`;
        }

        const formattedDateTime = `${formattedDate} | ${formattedTime}`;

        return formattedDateTime;
    }
    OnDownloadReport(ReportFileName, QueuedReportId) {
        this.spinner.show();
        let reportExcelFileName = '';
        switch (this.ReportMainData.reportCode) {
            case Report.ReportCode.BOOKEDTIMEBYRESOURCE_REPORTCODE:
                reportExcelFileName = Report.ReportFileName.BOOKEDTIMEBYRESOURCE_FILENAME;
                break;
            case Report.ReportCode.BOOKEDTIMEBYENGAGEMENT_REPORTCODE:
                reportExcelFileName = Report.ReportFileName.BOOKEDTIMEBYENGAGEMENT_FILENAME
                break;
            case Report.ReportCode.AVAILABILITYBYFORECASTEDHOURS_REPORTCODE:
                reportExcelFileName = Report.ReportFileName.AVAILABILITYBYFORECASTEDHOURS_FILENAME;
                break;
            case Report.ReportCode.AUDITTRAIL_REPORTCODE:
                reportExcelFileName = Report.ReportFileName.AUDITTRAIL_FILENAME;
                break;
            case Report.ReportCode.ADOPTION_REPORTCODE:
                reportExcelFileName = Report.ReportFileName.ADOPTION_FILENAME;
                break;
        }
        let downloadReportDto = new DownloadReportDto;
        downloadReportDto.reportFileName = ReportFileName;
        downloadReportDto.queuedReportId = QueuedReportId;
        let param = { base64string: btoa(unescape(encodeURIComponent(JSON.stringify(downloadReportDto)))) };
        let downloadReportInputDto = new DownloadReportInputDto;
        downloadReportInputDto.base64string = param.base64string;
        this.restService.downloadReport(downloadReportInputDto).subscribe({
            next: (respData: any) => {
                if (respData) {
                    if (respData?.body?.type && respData?.body?.type != 'application/json' && respData?.body?.type != 'text/plain') {
                        // const datepipe: DatePipe = new DatePipe('en-US')
                        // let formattedDate = datepipe.transform(new Date(), 'ddMMyyyyHHmmss')
                        this.downLoadFile(respData, ReportFileName);
                        this.messageTitle = 'Success';
                        this.messageBody = 'File downloaded successfully';
                        this.spinner.hide();
                    }
                    else {
                        this.messageTitle = 'Failed';
                        this.messageBody = 'Invalid Request.';
                    }
                }
            },
            error: (err: any) => {
                this.messageTitle = 'Failed';
                this.messageBody = 'Error while downloading report file!.';
            },
            complete: () => { this.spinner.hide(); }
        });
    }
    downLoadFile(response: any, fileName?: string) {
        const blob = new Blob([response.body], { type: response.headers.get('content-type') });
        var a = document.createElement('a');
        a.href = URL.createObjectURL(blob);
        a.download = fileName;
        a.click();
    }
    closeMessage() {
        this.messageBody = '';
        this.messageTitle = '';
    }
    refresh() {
        this.getQueuedReports(this.ReportMainData.reportId);
    }

    DeleteFilter(queueReportId) {
        this.spinner.show();
        let model = new DeleteQueueFilterDto();
        model.queueReportId = queueReportId;
        this.restService.deleteQueueReport(model).subscribe(response => {
          if (response.customResultId <= 0) {
            console.error('Error saving delete ', response.customException);
            this.messageTitle = 'Failed';
            this.messageBody = response.customException;
            this.onScroll();
          }
          else {
            console.log('Queue report deleted successfully', response);
            this.messageTitle = 'Success';
            this.messageBody = "Queue report deleted successfully.";
            this.onScroll();
          }
        }, error => {
          console.error('Error saving data', error);
          this.messageTitle = 'Failed';
          this.messageBody = "Unexpected server error. Please try again.";
          this.onScroll();
        }, () => {
          this.getQueuedReports(this.ReportMainData.reportId);
        });
      }


      onScroll() {
        this.restService.triggerNavigateToReportparent();
      }
      

}
